import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { ToastController, AlertController, LoadingController } from '@ionic/angular';
import { Camera, CameraResultType } from '@capacitor/camera';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit, OnChanges {

  @Input() user: any;
  @Input() userCategories: any[];
  
  userBackup: any;
  isOwnedProfile: boolean = false;
  isManagerSession: boolean = false;
  pictureUpdated: boolean = false;
  departments: string[];

  errors: string[];
  userChanges: any = {};
  toastEl: any;

  isNewUser: boolean = false;

  errorCodes = {
    'profile/no-mail': 'El correo electrónico es requerido',
    'auth/invalid-email': 'El correo electrónico tiene un formato incorrecto',
    'auth/wrong-password': 'La contraseña ingresada no es correcta.',
    'err/default': 'Ha ocurrido un error inesperado.'
  };

  constructor(
    private userService: UserService,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    private storageSvc: StorageService,
    private loadingCtrl: LoadingController) { 
      this.departments = userService.departments;
    }

  ngOnInit() {
    this.isManagerSession = (this.userService.currentUser && this.userService.currentUser.is_admin);
    this.userChanges = {};
  }

  ngOnChanges() {
    console.log('NgChanges Profile');
    this.isNewUser = false;
    this.isOwnedProfile = (this.user && this.user.id && this.user.id == this.userService.currentUser.id);
    this.isManagerSession = (this.userService.currentUser && this.userService.currentUser.is_admin);
    this.userBackup = Object.assign({}, this.user);

    console.log(this.user);

    //Check if user is new
    if (this.user && !this.user.id) {
      this.isNewUser = true;
    }
  }

  resetUser(){
    this.user = Object.assign({}, this.userBackup);
  }

  wasChanged(){
    let result = false;

    for(let k in this.user) {
      if(this.user[k] !== this.userBackup[k]) {
        result = true;
        break;
      }
    }

    return result;
  }

  async takePicture() {
    const image = await Camera.getPhoto({
      quality: 100,
      allowEditing: true,
      resultType: CameraResultType.DataUrl,
      width:500,
      height:500
    });
  
    // image.webPath will contain a path that can be set as an image src.
    // You can access the original file using image.path, which can be
    // passed to the Filesystem API to read the raw data of the image,
    // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)
    var imageUrl = image.dataUrl;
  
    // Can be set to the src of an image now
    this.user.pic_url = imageUrl;

    this.pictureUpdated = true;
  };

  async confirmProfileUpdate(form) {
    this.errors = [];

    if (this.toastEl) {
      this.toastEl.dismiss();
    }

    if (form.invalid) {
      this.errors.push('Hay campos incompletos o inválidos');
    }
    else if (this.isNewUser && this.user.pwCode !== this.user.pwCodeCheck) {
      this.errors.push('Las contraseñas no coinciden');
    }

    if (this.errors.length > 0) {
      this.toastEl = await this.toastCtrl.create({
        message: this.errors.join('\n'),
        cssClass: 'pane3-toast',
        position: 'bottom',
        color: 'danger',
        duration: 5000
      });
      this.toastEl.present();
    }
    else if (this.isNewUser) {
      this.createProfile();
    }
    else {
      this.alertCtrl.create({
        header: 'GUARDAR',
        message: 'Seguro quieres guardar los cambios?',
        buttons: [{
          text: 'CANCELAR',
          role: 'cancel',
        },{
          text: 'SI, SEGURO',
          handler: ()=>{
            this.updateProfile();
          }
        }],
      }).then(alert => {
        alert.present();
      });
    }
      
  }

  async updateProfile() {

    const loader = await this.loadingCtrl.create();
    loader.present();

    let updateObject:any = {}

    if (this.pictureUpdated) {
      const picSnap = await this.storageSvc.uploadProfilePic(this.user.pic_url);

      const pic = await picSnap.ref.getDownloadURL();
      
      updateObject.pic_url = pic;
    }

    for(let k in this.user) {
      if(k !== 'pic_url' && this.user[k] !== this.userBackup[k]) {
        updateObject[k] = this.user[k];
      }
    }

    this.userService.updateUser(this.user.id, updateObject).subscribe(res => {
      loader.dismiss();

      if (!res.error) {
        Object.assign(this.userBackup, updateObject);
        this.user = Object.assign({}, this.userBackup);
        this.pictureUpdated = false;
      }
      
    });    
  }

  async createProfile() {
    const loader = await this.loadingCtrl.create();
    loader.present();

    let updateObject:any = {}

    if (this.pictureUpdated) {
      const picSnap = await this.storageSvc.uploadProfilePic(this.user.pic_url);

      const pic = await picSnap.ref.getDownloadURL();
      
      updateObject.pic_url = pic;
    }

    for(let k in this.user) {
      if(k !== 'pic_url' && this.user[k] !== this.userBackup[k]) {
        updateObject[k] = this.user[k];
      }
    }

    this.userService.createUser(updateObject).subscribe(res => {
      loader.dismiss();

      if (!res.error) {
        updateObject.id = res.userId;  
        Object.assign(this.userBackup, updateObject);
        this.user = Object.assign({}, this.userBackup);
        this.pictureUpdated = false;
        this.isNewUser = false;
      }
      
    }); 

    /*this.userService.signUpOther(updateObject).then(id => {
      updateObject.uid = uid;  
      Object.assign(this.userBackup, updateObject);
      this.user = Object.assign({}, this.userBackup);
      this.pictureUpdated = false;
      this.isNewUser = false;

      loader.dismiss();
    },
    async err => {
      this.loadingCtrl.dismiss();
      const alert = await this.alertCtrl.create({
        header: ':(',
        message: err.message,
        buttons: ['OK'],
      });

      await alert.present();
    });*/
  }

  isUntouched(profileForm, field){
    return !profileForm.controls[field] || !profileForm.controls[field].touched;
  }
}
